import { motion } from "framer-motion";
import { makeStyles } from "@material-ui/core";
import { Input, Button, TextField } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px"
    },
    "& .MuiFormLabel-root": {
      color: "#eddbca", // or black
      outline: "red",
      fontSize: "13px",
      input: {
        color: "white"
      }
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2)
    },
    "& .MuiInputBase-root": {
      color: "#eddbca",
      fontSize: "14px"
    },
    input: {
      backgroundColor: "white",
      color: "white"
    },
    TextField: {
      color: "white"
    }
  }
}));
const Personal = ({ formData, setFormData, page, setPage, x, setX }) => {
  const classes = useStyles();
  const handleSubmit = () => {};
  return (
    <motion.div
      initial={{ x: x }}
      animate={{ x: 0 }}
      transition={{ duration: 1 }}
      className="card"
    >
      {/* <TextField
          label="Email"
         "
          type="email"
          name="email"
          required
          value={data.email}
          onChange={handleChange}
        /> */}
      <form className={classes.root} onSubmit={handleSubmit}>
        <h4 style={{ marginTop: 10, color: "white" }}>
          👉🏽 Personally related - 2/5❗️
        </h4>

        <TextField
          type="text"
          placeholder="Phone Number"
          variant="outlined"
          className="form-group"
          value={formData.phoneNumber}
          onChange={(e) =>
            setFormData({ ...formData, phoneNumber: e.target.value })
          }
        />
        <TextField
          type="text"
          className="form-group"
          placeholder="Birth Day"
          variant="outlined"
          value={formData.birthday}
          onChange={(e) =>
            setFormData({ ...formData, birthday: e.target.value })
          }
        />
      </form>
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: 10, marginRight: 10 }}
        onClick={() => {
          setPage(page - 1);
          setX(-1000);
        }}
      >
        Previous
      </Button>
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: 10 }}
        onClick={() => {
          setPage(page + 1);
          setX(1000);
        }}
      >
        Next
      </Button>
    </motion.div>
  );
};

export default Personal;
